<template>
  <img 
    src="../assets/images/thumb-up.jpg"
    :alt="$t('averageDeviation.alt.up')"
    width="30"
    height="30"
    v-if="tendency >= 0" />
</template>

<script>
export default {
  props: ['tendency']
};
</script>



// WEBPACK FOOTER //
// src/components/AverageDeviation.vue